import { render, staticRenderFns } from "./TicketsDashboard.vue?vue&type=template&id=b34f341c&scoped=true&"
import script from "./TicketsDashboard.vue?vue&type=script&lang=ts&"
export * from "./TicketsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsDashboard.vue?vue&type=style&index=0&id=b34f341c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34f341c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSnackbar})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b34f341c')) {
      api.createRecord('b34f341c', component.options)
    } else {
      api.reload('b34f341c', component.options)
    }
    module.hot.accept("./TicketsDashboard.vue?vue&type=template&id=b34f341c&scoped=true&", function () {
      api.rerender('b34f341c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/views/TicketsDashboard.vue"
export default component.exports